import { render } from "./ReviewTaskSearchWidget.vue?vue&type=template&id=19dc1344&ts=true"
import script from "./ReviewTaskSearchWidget.ts?vue&type=script&lang=ts&external"
export * from "./ReviewTaskSearchWidget.ts?vue&type=script&lang=ts&external"

import "./ReviewTaskSearchWidget.vue?vue&type=style&index=0&id=19dc1344&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__